import React, { useState } from 'react'
import logo from './Logo_peristeri.jpg';
import {
    Card,
    Checkbox,
    FormControlLabel,
    Grid,
    Button,
    CircularProgress,
} from '@material-ui/core'
import { TextValidator, ValidatorForm } from 'react-material-ui-form-validator'

import { makeStyles } from '@material-ui/core/styles'
import history from 'history.js'
import clsx from 'clsx'
import useAuth from 'app/hooks/useAuth'
import { getInfos } from 'api';
import { useEffect } from 'react';
import CircularLoadingIndicator from 'app/appComponents/CorcularLoadingIndicator';

const useStyles = makeStyles(({ palette, ...theme }) => ({
    cardHolder: {
        background: '#1A2038',
    },
    card: {
        maxWidth: 800,
        borderRadius: 12,
        margin: '1rem',
    },
    buttonProgress: {
        position: 'absolute',
        top: '50%',
        left: '50%',
        marginTop: -12,
        marginLeft: -12,
    },
}))

const JwtLogin = () => {
    const localUrl = process.env.REACT_APP_LOCAL_URL;
    const productionUrl = "/"
    const [loading, setLoading] = useState(false)
    const [userInfo, setUserInfo] = useState({
        // email: 'dimos@peristeri.com',
        // password: 'peristeri',
    })
    const [message, setMessage] = useState('')
    const { login } = useAuth()

    const [appInfos, setAppInfos] = useState()
    const classes = useStyles()

    useEffect(() => {

        fetchAppInfosFromServer().then((_data) => {
            setAppInfos(_data)
        })


    }, [])

    !appInfos &&
        fetchAppInfosFromServer().then((_data) => {
            setAppInfos(_data)
        })

    const handleChange = ({ target: { name, value } }) => {
        let temp = { ...userInfo }
        temp[name] = value
        setUserInfo(temp)
    }

    const handleFormSubmit = async (event) => {
        setLoading(true)
        try {
            await login(userInfo.email, userInfo.password)
            history.push('/')
        } catch (e) {
            console.log("The message is: ", e)
            setMessage("ERROR")
            setLoading(false)
        }
    }

    if (!appInfos) {

        return <CircularLoadingIndicator />
    }

    return (
        <div
            className={clsx(
                'flex justify-center items-center  min-h-full-screen',
                classes.cardHolder
            )}
        >
            
            <Card className={classes.card}>
            
                <Grid container>
               
                    <Grid item lg={5} md={5} sm={5} xs={12}>
                    <div className=' pt-5 flex justify-center items-center'>{appInfos.city}</div>
                   
                        <div className="pb-8 flex justify-center items-center h-full">
                        
                            <img
                                className="w-200"

                                //src={process.env.NODE_ENV === 'production' ? productionUrl : localUrl +'/infos/logo.jpg'}
                                src={appInfos.logo}
                                alt=""
                            />
                        </div>
                    </Grid>
                    <Grid item lg={7} md={7} sm={7} xs={12}>
                        <div className="p-8 h-full bg-light-gray relative">
                            <ValidatorForm onSubmit={handleFormSubmit}>
                                <TextValidator
                                    className="mb-6 w-full"
                                    variant="outlined"
                                    size="small"
                                    label="Email"
                                    onChange={handleChange}
                                    type="email"
                                    name="email"
                                    value={userInfo.email}
                                    validators={['required', 'isEmail']}
                                    errorMessages={[
                                        'this field is required',
                                        'email is not valid',
                                    ]}
                                />
                                <TextValidator
                                    className="mb-3 w-full"
                                    label="Password"
                                    variant="outlined"
                                    size="small"
                                    onChange={handleChange}
                                    name="password"
                                    type="password"
                                    value={userInfo.password}
                                    validators={['required']}
                                    errorMessages={['this field is required']}
                                />
                                <FormControlLabel
                                    className="mb-3 min-w-288"
                                    name="agreement"
                                    onChange={handleChange}
                                    control={
                                        <Checkbox
                                            size="small"
                                            onChange={({
                                                target: { checked },
                                            }) =>
                                                handleChange({
                                                    target: {
                                                        name: 'agreement',
                                                        value: checked,
                                                    },
                                                })
                                            }
                                            checked={userInfo.agreement || true}
                                        />
                                    }
                                    label="Αποθήκευση"
                                />

                                {message && (
                                    <p className="text-error">{message}</p>
                                )}

                                <div className="flex flex-wrap items-center mb-4">
                                    <div className="relative">
                                        <Button
                                            variant="contained"
                                            color="primary"
                                            disabled={loading}
                                            type="submit"
                                        >
                                            Είσοδος
                                        </Button>

                                        {loading && (
                                            <CircularProgress
                                                size={24}
                                                className={
                                                    classes.buttonProgress
                                                }
                                            />
                                        )}
                                    </div>
                                    {/* <span className="mr-2 ml-5">or</span> */}
                                    {/* <Button
                                        className="capitalize"
                                        onClick={() =>
                                            history.push('/session/signup')
                                        }
                                    >
                                        Sign up
                                    </Button> */}
                                </div>
                                {/* <Button
                                    className="text-primary"
                                    onClick={() =>
                                        history.push('/session/forgot-password')
                                    }
                                >
                                    Forgot password?
                                </Button> */}
                            </ValidatorForm>
                        </div>
                    </Grid>
                </Grid>
            </Card>
        </div>
    )
}


async function fetchAppInfosFromServer() {
    try {
        let data = await getInfos()
       
        return data.data

    } catch (error) {
        return { error: 'error getting data' }
    }
}

export default JwtLogin
